import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import CustomButton from "components/Atoms/CustomButton"
import OrderDetailDialog from "components/Templates/order/OrderDetailDialog"
import AppToaster from "utils/AppToaster"
import {
  useDispatchOrdersList,
  useSummaryAllOrders,
} from "graphql/dispatch/dispatch.hooks"
import { useTotalSelectedOrders } from "store/dispatch.redux"
import Order from "./Order"
import TripStepPanel from "./TripStepPanel"
import VehicleSelector from "./VehicleSelector"
import OrderItemsPanel from "./OrderItemsPanel"
import useAuth from "hooks/useAuth"
import { useLazyQuery } from "@apollo/client"
import { SUBORDER_ORDER_DETAIL } from "graphql/dispatch/dispatch.queries.gql"
const OrdersPanel = ({ openPanel, closePanel, parentOrder = null }) => {
  const auth = useAuth()
  const [subOrders, setSubOrders] = useState([])
  const [getSubOrders] = useLazyQuery(SUBORDER_ORDER_DETAIL, {
    onCompleted: data => {
      setSubOrders(data?.orderDetail?.subOrders || [])
    },
  })
  const { data: orders } = useDispatchOrdersList()
  const [orderId, setOrderId] = useState(null)
  const { total, items } = useTotalSelectedOrders()
  const { id } = useParams()
  const { data: response } = useSummaryAllOrders()

  const summary = response?.summaryAllOrders

  useEffect(() => {
    if (parentOrder && parentOrder?.id && subOrders?.length === 0) {
      getSubOrders({ variables: { orderId: parentOrder.id } })
    }
  }, [subOrders, parentOrder, getSubOrders])

  return (
    <div>
      {auth.user.currentDepartment.isB2c &&
      subOrders &&
      subOrders.length > 0 ? (
        <div className="px-3 py-2 flex items-baseline">
          <CustomButton
            className="mr-3"
            icon="arrow-left"
            minimal
            onClick={closePanel}
          />
          <h6>
            {parentOrder?.user?.fullName} -{" "}
            <span className="vt-muted">
              {parentOrder?.shippingAddress?.village}
            </span>
            <div className="vt-muted text-sm">
              Suborders for: {parentOrder?.trackingCode}
            </div>
          </h6>
        </div>
      ) : (
        <div className="ds-vehicle-selector-header">
          <VehicleSelector />
          <div className="statuses">
            <span>
              <strong className="vt-warning">
                {summary?.statusReadyForSchedule ?? "Na"}
              </strong>{" "}
              <span className="vt-muted">RFS</span>
            </span>
            <span>
              <strong className="vt-success">
                {summary?.statusReadyForDespatch ?? "Na"}{" "}
              </strong>
              <span className="vt-muted">RFD</span>
            </span>
          </div>
        </div>
      )}
      <section className="vt-panel">
        {auth.user.currentDepartment.isB2c && subOrders && subOrders.length > 0
          ? subOrders?.map?.(order => {
              return (
                <Order
                  onOrderEdit={() => {
                    openPanel({
                      component: OrderItemsPanel,
                      title: `Items for order - ${order?.trackingCode}`,
                      props: { orderId: order?.id },
                    })
                  }}
                  isSubOrder={true}
                  key={order?.id}
                  order={order}
                  onClick={e => setOrderId(order?.id)}
                />
              )
            })
          : orders?.map?.(order => {
              return (
                <Order
                  onOrderEdit={() => {
                    if (
                      auth.user.currentDepartment.isB2c &&
                      order.subOrders?.length > 0
                    ) {
                      openPanel({
                        component: OrdersPanel,
                        title: "Orders",
                        props: {
                          parentOrder: order,
                        },
                      })
                    } else {
                      openPanel({
                        component: OrderItemsPanel,
                        title: `Items for order - ${order?.trackingCode}`,
                        props: { orderId: order?.id },
                      })
                    }
                  }}
                  key={order?.id}
                  order={order}
                  onClick={e => setOrderId(order?.id)}
                />
              )
            })}{" "}
      </section>

      <div className="p-3 vt-dispatch-panel-button">
        <CustomButton
          fill
          big
          intent="primary"
          rightIcon="arrow-right"
          text={
            (
              <span>
                Checked{" "}
                <span
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {total}
                </span>{" "}
                Orders &{" "}
                <span
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {items}
                </span>{" "}
                Items
              </span>
            ) as any
          }
          onClick={() => {
            if (parseInt(id)) {
              openPanel({
                component: TripStepPanel,
                title: "Make Trip",
              })
              return
            }
            if (!total || total === 0) {
              AppToaster.show({
                message: "Please select atleast 1 order before continuing",
                icon: "warning-sign",
                intent: "warning",
              })
              return
            }
            openPanel({
              component: TripStepPanel,
              title: "Make Trip",
            })
          }}
        />
      </div>
      <OrderDetailDialog
        orderId={orderId}
        isOpen={orderId ? true : false}
        onClose={() => setOrderId(null)}
      />
    </div>
  )
}

export default OrdersPanel
